import { Validator, ValidationArguments } from 'class-validator';

export class CustomCommonValidator {
	validator: Validator = new Validator();
	message: string = '';

	getValidator(): Validator {
		return this.validator;
	}

	defaultMessage(validationArguments?: ValidationArguments): string { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/customCommonValidator.ts